<template>
  <div class="questions">
    <div class="questionsBox">
      <el-row>
        <el-col :span="22" ref="title_ref" v-model="titleShow">{{titleShow}}</el-col>
        <el-col :span="2">
          <el-button
            type="info"
            round
            icon="el-icon-back"
            size="small"
            @click="goBack()"
          >
            返 回
          </el-button>
        </el-col>
      </el-row>
      <div class="formBox">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleFormRef"
          label-width="100px"
        >
          <el-form-item label="题目名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入题目名称"
              maxlength="122"
            ></el-input>
          </el-form-item>

          <el-form-item label="题目分类" prop="questionCategory">
            <el-radio-group v-model="ruleForm.type">
              <el-radio :label="1" >陈列</el-radio>
              <el-radio :label="2" >运营</el-radio>
              <el-radio :label="3" >培训</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="检查项" prop="checkOption">
            <el-select
              v-model="ruleForm.checkItemID"
              clearable
              placeholder="检查项名称"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in checkItemList"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="题目题干" prop="questionContent">
            <el-input
              type="textarea"
              v-model="ruleForm.stem"
              placeholder=""
              maxlength="256"
            ></el-input>
          </el-form-item>

          <el-form-item label="执行要求" prop="demand">
            <el-input
              type="textarea"
              v-model="ruleForm.requires"
              placeholder=""
              maxlength="256"
            ></el-input>
          </el-form-item>

          <el-form-item label="图片/视频" prop="demand">
            <el-checkbox v-model="ruleForm.isRequired">必填</el-checkbox>
          </el-form-item>

          <el-form-item label="图片示例" prop="images">
            <el-upload
              :action="attachmentsUploadUrl"
              :file-list="ruleForm.images"
              list-type="picture-card"
              :on-remove="handleRemove"
              :headers="myHeaders"
              :limit="3"
              :data="{type: 5}"
              :on-success="handleUploadSuccess"
              accept=".png,.jpg"
              :class="{ 'hide-upload': ruleForm.images.length >= 3 }"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <span class="tip">最多可添加3张图片</span>
          </el-form-item>

          <videoUpload
            v-model="ruleForm.video"
            label="视频简介"
            :type="5"
            text="只能上传视频文件，且不超过100M"
          />

          <el-form-item label="分值" prop="score">
            <el-input-number
              v-model="ruleForm.score"
              :min="0"
              :max="9"
            >
            </el-input-number>
          </el-form-item>

          <div class="options">
            <span class="label">题目选项</span>
            <div class="optionsContent">
              <div class="panel">A.选项名称 <b>是</b></div>
              <div class="panel">B.选项名称 <b>否</b></div>
              <div class="panel panelBig">
                <div class="line1">
                  C.选项名称
                  <b>不适用</b>
                  <div class="disableSkip">
                    <el-switch
                      v-model="ruleForm.inapplicability"
                      active-color="#67C23A" @change="getQuestionList"
                    >
                    </el-switch>
                    <em>启用</em>
                  </div>
                </div>
                <div class="line2" v-show="ruleForm.inapplicability">
                  选中时跳过
                  <el-select class="skipSelect" v-model="ruleForm.skip" multiple placeholder="请选择">
                    <el-option
                      v-for="item in questionsList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <footer>
        <el-button type="success" @click="save()">
          保 存
        </el-button>
      </footer>
    </div>
  </div>
</template>
<script>
import md5 from "md5";
import Cookies from 'js-cookie'
import videoUpload from "../../../components/videoUpload";
import _ from "lodash"

export default {
  name: "QuestionsEdit",
  components: {
    videoUpload,
  },
  data() {
    const domain = window.location.origin;
    return {
      myHeaders: { token: Cookies.get('token')},
      // attachmentsUploadUrl: "/pubServer/upload/upload",
      attachmentsUploadUrl: "/public-service/upload/upload",
      id: this.$route.query.id || null,
      titleShow: "",
      editRow: {},
      categoryList: [
        {
          name: '分类1',
          categoryNo: 1
        },
        {
          name: '分类2',
          categoryNo: 2
        },
      ],
      checkOptionList: [],
      rules: {}, // 验证信息
      ruleForm: {
        id: "",
        name: "",  //题目名称
        stem: "", //题目题干
        type: null, //题目分类
        checkItemID: "", //检查项
        requires: "", //执行要求
        score: "", //分值
        inapplicability: false, //是否适用
        skip:[], //跳过题目,
        images: [],
        isRequired: false //图片视频必填
      },
      questionsList: []  //问题列表
    }
  },
  computed: {
    checkItemList: ({ $store: { getters } }) => getters.checkItemList // 检查项
  },
  mounted() {
    this.getData()
    this.getQuestionList()
    this.$store.dispatch("getStoreCheckItems"); // 检查项
  },
  methods: {
    handleRemove(file, fileList) {
      // 查找被删除文件的索引
      const index = this.ruleForm.images.findIndex(item => item.url === file.url);
      console.log('删除的是第', index, '个文件');
      this.ruleForm.images.splice(index, 1);
    },
    handleUploadSuccess(res, file) {
      let imgUrl = file.response.data.result.imageUrl
      console.log('imgUrl', imgUrl)
      this.ruleForm.images.push(
        {
          name: '',
          url: imgUrl
        }
      );
    },
    async getQuestionList(){
      if ( this.questionsList.length > 0)
        return;
      // 获取列表
      let res = await axios.post(oprReqUrl+"/question/search", {});
      res = res.data;
      if (res.code === 200) {
        this.questionsList = res.data.list || [];
        this.total = res.data.total;
        await this.getSkipById();
      }
    },
    async getSkipById(){
      let res = await axios.post(oprReqUrl+"/question/skip", {"id":this.ruleForm.id});
      res = res.data;
      if (res.code === 200) {
        let skipData = res.data;
        let skipId = [];
        if (skipData && skipData.length) {
          skipData.forEach(function (item){
            skipId.push(item.id)
          })
        }
        this.$set(this.ruleForm, "skip", skipId)
      }
    },
    async getTitle() {
      if (this.$route.query.id != null){  //编辑
        this.titleShow = "编辑题目";
      }else { //新增
        this.titleShow = "新增题目";
      }
    },
    async getData() {
      const id = this.id;
      if (id == null){
        return
      }
      let res = await axios.post(oprReqUrl+"/question/detail", { id });
      res = res.data;
      if (res.code === 200) {
        this.ruleForm = res.data;
        const fileList = []
        _.each(this.ruleForm.images, (img) => {
          fileList.push({
            name: '',
            url: img
          })
        })
        this.ruleForm.images = fileList
      }
    },
    goBack() {
      this.$router.push({ path: '/opr/questions', query: {current: this.$route.query.current || 1} });
    },
    async save() {


      const submitData = _.cloneDeep(this.ruleForm)
      const fileList = []
      _.each(this.ruleForm.images, (img) => {
        fileList.push(img.url)
      })
      submitData.images = fileList
      console.log('submitData', submitData)
      // return false
      let res = await axios.post(oprReqUrl+"/question/save", submitData);
      res = res.data;
      if (res.code === 200) {
        this.$message.success(res.message == null ? "success" : res.message)
        // await this.$router.push({ path: '/pages/questions' });
        await this.goBack();
      }
    }
  }
};
</script>
<style>
.hide-upload .el-upload--picture-card {
  display: none;
}
.el-upload-list__item {
  transition: none !important; /* 完全禁用过渡效果 */
}
</style>
<style lang="sass" scoped>
.questions
  min-width: 1050px
  .questionsBox
    padding: 20px
    .tip
      color: #606266
    .formBox
      width: 50%
      margin-left: 25%
      margin-top: 20px

    .options
      display: flex
      .label
        text-align: right
        width: 100px
        vertical-align: middle
        float: left
        font-size: 14px
        color: #606266
        line-height: 36px
        padding: 0 12px 0 0
        -webkit-box-sizing: border-box
        box-sizing: border-box
        flex-shrink: 0
      .panel
        height: 36px
        line-height: 36px
        background-color: #FFF
        border-radius: 4px
        border: 1px solid #DCDFE6
        -webkit-box-sizing: border-box
        box-sizing: border-box
        color: #ccc
        display: inline-block
        outline: 0
        padding: 0 15px
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1)
        transition: border-color .2s cubic-bezier(.645,.045,.355,1)
        width: 100%
        font-size: 14px
        b
          color: #606266
          font-weight: 400
          margin-left: 30px
        margin-bottom: 10px
      .panelBig
        height: auto
        padding-top: 20px
        padding-bottom: 20px
        .line2
          margin-top: 12px
      .disableSkip
        float: right
        margin-right: 16px
        em
          font-style: normal
          color: #606266
      .skipSelect
        margin-left: 30px
        width: calc(100% - 120px)
    footer
      padding-top: 20px
      text-align: center
</style>



// WEBPACK FOOTER //
// src/opr/pages/views/Check/questionsEdit.vue